import { useContext } from 'react';
import { VoidReturn } from '../../../Utils/PageUtils';
import { ProgressBarCalculateCurrentProgress } from '../../../Utils/ProgressBarService';
import { HearingAssessmentState, HLAAContext } from '../HLAAContext';

export type HearingAssessmentPlayHandler = {
    playTone: () => VoidReturn;
    getTopProgress: () => number;
};

export default function useHearingAssessmentPlayHandler(): HearingAssessmentPlayHandler {
    const { info, setHearingAssessmentState } = useContext(HLAAContext);

    const getTopProgress = (): number => {
        return ProgressBarCalculateCurrentProgress(
            info.current.totalPageCount,
            info.current.totalPagesForProgress
        );
    };

    const playTone = () => {
        setHearingAssessmentState(HearingAssessmentState.AssessmentOneSide);
    };

    return {
        playTone,
        getTopProgress,
    };
}
